import { CWFilterBaseModel } from 'src/core/models/cwFilterBase.model';

export class CWListerecpFilterModel extends CWFilterBaseModel {

  constructor() {
    super()
  }
}
